/**
 * Ponawianie zapytań React Query (Fala 4, grupa 160). Odmowa (401, 403) i brak
 * zasobu (404) są odpowiedzią, a nie awarią: ponowienie dawało drugi wpis
 * access.denied w dzienniku za jedno wejście. Inne błędy — jedna próba więcej.
 */
import { ApiError } from './client'

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && [401, 403, 404].includes(error.status)) return false
  return failureCount < 1
}
